import { useEffect, useRef, useState } from 'react';

type SubscribeFn<T> = (
  onUpdate: (data: T) => void,
  onError: (error: Error) => void,
) => () => void;

export function useFirestoreSubscription<T>(
  subscribe: SubscribeFn<T>,
  initialData: T,
): { data: T; loading: boolean } {
  const [data, setData] = useState<T>(initialData);
  const [loading, setLoading] = useState(true);
  const subscribeRef = useRef(subscribe);

  useEffect(() => {
    const unsubscribe = subscribeRef.current(
      updated => {
        setData(updated);
        setLoading(false);
      },
      _error => {
        setData(initialData);
        setLoading(false);
      },
    );
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, loading };
}
